export default {
      id: "footer_appli-usage",
      viewBox: "0 0 40 50",
      url: "../dist/images/" + "sprite.svg#footer_appli-usage",
      toString: function () {
        return this.url;
      }
    }